(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["medicair-filter-plan"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('medicair-filter-plan')) {
  customElements.define('medicair-filter-plan', class extends HTMLElement {
    connectedCallback() {
      const update = () => {
        let choice = this.querySelector('input[name="selling_plan"]:checked');
        if (!choice) {
          choice = this.querySelector('input[name="selling_plan"]');
          if (choice) choice.checked = true;
        }
        if (choice) {
          this.querySelector('[data-plan-price]').textContent = choice.dataset.price;
          this.querySelector('[data-plan-saving]').textContent = choice.dataset.saving;
          this.querySelector('[data-plan-timing]').textContent = choice.dataset.timing;
        }
      };
      this.addEventListener('change', update);
      update();
    }
  });
}
if (!customElements.get('medicair-plan-link')) {
  customElements.define('medicair-plan-link', class extends HTMLElement {
    connectedCallback() {
      const requested = new URLSearchParams(location.search).get('selling_plan');
      if (!requested || !/^\d+$/.test(requested)) return;
      let done = false;
      const apply = () => {
        if (done) return;
        const select = document.querySelector('.recurpay__frequency_select');
        const radio = document.querySelector('.recurpay__subscribe_radio');
        const hidden = document.querySelector('.recurpay_selling_plan_id');
        if (!select || !radio || !hidden) return;
        const index = Array.from(select.options).findIndex(option => option.dataset.sellingPlan === requested);
        if (index < 0) return;
        done = true;
        this.observer?.disconnect();
        requestAnimationFrame(() => {
          if (!radio.checked) radio.click();
          select.selectedIndex = index;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          if (location.hash === '#filter-subscription') {
            select.closest('.recurpay__widget')?.scrollIntoView({ block: 'center' });
          }
        });
      };
      this.observer = new MutationObserver(apply);
      this.observer.observe(document.body, { childList: true, subtree: true });
      apply();
      this.timer = setTimeout(() => this.observer?.disconnect(), 30000);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      clearTimeout(this.timer);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
